module.exports = __webpack_public_path__ + "static/media/users.1dfe81c6.svg";